import React, { Component } from "react";
import PropTypes from "prop-types";
import S3browser from "@realgeeks/s3browser";

class S3BrowserModal extends Component {
  constructor(props) {
    super(props);
  }

  render_browser() {
    if (this.props.directory !== undefined && this.props.status == "show") {
      return <S3browser {...this.configurations()} />;
    } else {
      return <div className="newman__loading" />;
    }
  }

  configurations() {
    return {
      bucket: "u.realgeeks.media",
      cdnURL: "http://u.realgeeks.media",
      userPrefix: this.props.directory,
      dynamoTable: "s3browser",
      awsCredsURL: this.props.creds_url,
      basePath: "/",
      onInsert: this.insert_selected.bind(this),
      useRouter: true,
      fileTypes: {
        mimetypes: ["image/jpeg", "image/gif", "image/png"],
        extensions: [".jpg", ".jpeg", ".png", ".gif"]
      },
      excludeFiles: false
    };
  }

  insert_selected(file) {
    this.props.insert(file);
  }

  render() {
    return (
      <div className="newman__overlay">
        <div className="newman__modal">{this.render_browser()}</div>
      </div>
    );
  }
}

export default S3BrowserModal;
